import { useImportJson } from "@/shared/hooks/useImportJson";
import { IconButton, Tooltip } from "@radix-ui/themes";
import { useRef } from "react";

export function ImportJsonButton({
  onImport,
  tooltip,
  children,
}: {
  onImport: (value: any) => void;
  tooltip: string;
  children: React.ReactNode;
}) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const importJson = useImportJson();

  const onImportClick = () => {
    inputRef.current?.click();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    e.preventDefault();

    importJson(e.target.files[0]).then((value) => {
      onImport(value);
    });
  };

  return (
    <div className="flex">
      <Tooltip content={tooltip}>
        <IconButton
          onClick={onImportClick}
          size="1"
          variant="soft"
          color="gray"
        >
          {children}
        </IconButton>
      </Tooltip>
      <input
        ref={inputRef}
        onChange={onChange}
        className="min-h-0 h-0 max-h-0 invisible overflow-hidden w-0"
        type="file"
        multiple={false}
        accept=".json"
      />
    </div>
  );
}
